<div *ngIf="item.subProject.stockAtBranch" class="flex-row">
  <mat-card class="summary-card info yellow">
    <div class="flex-row">
      <span
        >Let op: uitgesteld bord<br />Filiaal:
        {{ item.subProject.stockAtBranch }}</span
      >
    </div>
  </mat-card>
</div>
<div *ngIf="item.required.atelierInfo" class="flex-row">
  <ng-container
    *ngIf="item.subProject.expectedType === SUB_PROJECT_TYPES.BASE_PROJECT"
  >
    <mat-card class="summary-card info yellow">
      <div class="with-newline">
        <ul class="p-0" style="list-style-type: none">
          <li *ngIf="item.subProject.project?.firstProduct?.studioValue">
            {{ item.subProject.project?.firstProduct?.studioInfo }}
          </li>
          <li *ngIf="item.subProject.project?.firstProduct?.studioRightValue">
            {{ item.subProject.project?.firstProduct?.studioRightInfo }}
          </li>
          <li *ngIf="item.subProject.project?.firstProduct?.studioTitleValue">
            {{ item.subProject.project?.firstProduct?.studioTitleInfo }}
          </li>
          <li
            *ngIf="item.subProject.project?.firstProduct?.studioTitleRightValue"
          >
            {{ item.subProject.project?.firstProduct?.studioTitleRightInfo }}
          </li>
          <li
            *ngIf="
              item.subProject.project?.firstProduct?.studioPhoneNumberValue
            "
          >
            {{ item.subProject.project?.firstProduct?.studioPhoneNumberInfo }}
          </li>
          <li
            *ngIf="
              item.subProject.project?.firstProduct?.studioPhoneNumberRightValue
            "
          >
            {{
              item.subProject.project?.firstProduct?.studioPhoneNumberRightInfo
            }}
          </li>
          <li *ngIf="item.subProject.project?.firstProduct?.studioStickerValue">
            {{ item.subProject.project?.firstProduct?.studioStickerInfo }}
          </li>
          <li
            *ngIf="
              item.subProject.project?.firstProduct?.studioStickerRightValue
            "
          >
            {{ item.subProject.project?.firstProduct?.studioStickerRightInfo }}
          </li>
        </ul>
      </div>
    </mat-card>
  </ng-container>
  <ng-container
    *ngIf="item.subProject.expectedType === SUB_PROJECT_TYPES.SOLDRENTED"
  >
    <mat-card class="summary-card info">
      <div class="flex-row">
        <span>{{ item.subProject.signSticker?.atelierInfo }}</span>
      </div>
    </mat-card>
  </ng-container>
  <mat-card class="mat-elevation-z0 summary-card progress">
    <mat-checkbox
      [disabled]="finishDisabled"
      [ngModel]="item.checked.atelierInfo"
      (ngModelChange)="markDoneAtelierInfo($event)"
    >
      {{
        item.subProject.expectedType === SUB_PROJECT_TYPES.SOLDRENTED
          ? 'Atelier info sticker'
          : 'Gelezen'
      }}
    </mat-checkbox>
  </mat-card>
</div>

<div *ngIf="item.subProject.atelierExtraInfo?.length > 0" class="flex-row">
  <mat-card class="summary-card info atelier">
    <div class="flex flex-col">
      <span class="highlighted with-newline">{{
        item.subProject.atelierExtraInfo
      }}</span>
      <p class="bold" *ngIf="item.subProject.createNewBoard">
        Nieuw bord aanmaken
      </p>
      <p class="bold" *ngIf="item.subProject.subBoardsRequired">
        Tekst/onderborden nodig
      </p>
    </div>
  </mat-card>
  <mat-card class="mat-elevation-z0 summary-card progress">
    <mat-checkbox
      [disabled]="finishDisabled"
      [ngModel]="item.checked.atelierExtraInfo"
      (ngModelChange)="markDoneAtelierExtraInfo($event)"
    >
      Extra info voor atelier
    </mat-checkbox>
  </mat-card>
</div>

<div
  class="flex-row"
  *ngIf="item.subProject.expectedType !== SUB_PROJECT_TYPES.SOLDRENTED"
>
  <mat-card class="mat-elevation-z0 summary-card info">
    <div class="flex-row">
      <div class="inner-info label-mb-0">
        <label class="strong">{{ title }}:</label>
        <label
          *ngIf="
            item.subProject.project?.firstProduct?.boardType?.ordinal !==
            BOARD_TYPE_CHOICES.DIVERGENT.ordinal
          "
          class="highlighted small"
        >
          <ng-container *ngIf="boardSummaryRight != null"> Links</ng-container>
          {{ boardSummary }}

          <ng-container *ngIf="boardSummaryRight != null">
            <br />Rechts {{ boardSummaryRight }}
          </ng-container>
        </label>
        <label
          *ngIf="
            item.subProject.expectedType === SUB_PROJECT_TYPES.BASE_PROJECT &&
            !item.subProject.project?.firstProduct?.withoutStock
          "
        >
          Rek:
          {{ item.subProject.project?.firstProduct?.physicalStockShelfAmount }}
          / Dak:
          {{ item.subProject.project?.firstProduct?.physicalStockRoofAmount }}
        </label>

        <label class="strong" style="margin-top: 15px">
          {{ item.subProject.project?.firstProduct?.format }} -
          {{ item.subProject.project?.firstProduct?.placementDetail }}
        </label>
        <label
          *ngIf="item.subProject.project?.firstProduct?.materialDisplayName"
          >{{
            item.subProject.project?.firstProduct?.materialDisplayName
          }}</label
        >
        <label *ngIf="item.subProject.project?.firstProduct?.signFrame != null">
          Frame:
          {{ item.subProject.project?.firstProduct?.signFrame?.label }}</label
        >
        <label
          *ngIf="item.subProject.project?.firstProduct?.signFrameColor != null"
        >
          Frame kleur:
          {{
            item.subProject.project?.firstProduct?.signFrameColor?.label
          }}</label
        >
      </div>
      <div class="inner-picture">
        <img
          *ngIf="
            item.subProject.project &&
            item.subProject.project.firstProduct &&
            item.subProject.project.firstProduct.boardType
          "
          class="config-img"
          [src]="placementTypePreviewUrl"
        />
      </div>
    </div>
  </mat-card>

  <mat-card class="mat-elevation-z0 summary-card progress">
    <mat-checkbox
      *ngIf="
        item.required.configuration &&
        item.subProject.expectedType === SUB_PROJECT_TYPES.BASE_PROJECT
      "
      [disabled]="finishDisabled"
      [ngModel]="item.checked.configuration"
      (ngModelChange)="markDoneConfiguration($event)"
      [class.wide]="
        printRegisteredUser &&
        item.subProject?.project?.firstProduct?.ipBoardCheckedPrintWork
      "
    >
      <div class="d-flex justify-content-between w-100 flex-wrap">
        <span
          >{{ title }}
          <span *ngIf="!!item.subProject.project?.firstProduct?.signId">
            ({{
              !!item.subProject.project?.firstProduct?.withoutStock
                ? 'zonder voorraad'
                : 'in stock'
            }})
          </span>
        </span>
        <div
          *ngIf="
            printRegisteredUser &&
            item.subProject?.project?.firstProduct?.ipBoardCheckedPrintWork
          "
          class="d-flex ml-1"
        >
          <div class="circle">{{ printRegisteredUser }}</div>
          <span>{{ printRegisteredDate | date : 'dd/MM/yyyy' }}</span>
        </div>
      </div>
    </mat-checkbox>

    <mat-checkbox
      *ngIf="
        item.required.frame &&
        [
          SUB_PROJECT_TYPES.BASE_PROJECT.valueOf(),
          SUB_PROJECT_TYPES.ADJUSTMENT.valueOf()
        ].includes(item.subProject.expectedType)
      "
      [disabled]="finishDisabled"
      [ngModel]="item.checked.frame"
      (ngModelChange)="markDoneFrame($event)"
    >
      <div class="d-flex justify-content-between w-100 flex-wrap">
        <span>
          Frame : {{ item.subProject.project?.firstProduct?.signFrame?.label }}
        </span>
      </div>
    </mat-checkbox>

    <mat-checkbox
      *ngIf="
        item.required.frameColor &&
        [
          SUB_PROJECT_TYPES.BASE_PROJECT.valueOf(),
          SUB_PROJECT_TYPES.ADJUSTMENT.valueOf()
        ].includes(item.subProject.expectedType) &&
        item.subProject.project.firstProduct.signFrameColor
      "
      [disabled]="finishDisabled"
      [ngModel]="item.checked.frameColor"
      (ngModelChange)="markDoneFrameColor($event)"
    >
      <div class="d-flex justify-content-between w-100 flex-wrap">
        <span>
          Frame kleur :
          {{ item.subProject.project?.firstProduct?.signFrameColor?.label }}
        </span>
      </div>
    </mat-checkbox>
  </mat-card>
</div>

<div class="flex-row">
  <mat-card
    *ngIf="item.subProject.expectedType === SUB_PROJECT_TYPES.BASE_PROJECT"
    class="mat-elevation-z0 summary-card info base-project"
  >
    <div class="flex-row">
      <div class="inner-info">
        <ul class="inpress-ul">
          <li>
            <span
              >Titel{{
                item.subProject.project.firstProduct &&
                item.subProject.project.firstProduct.doTitleSidesDiffer
                  ? ' links'
                  : ''
              }}:
            </span>
            <span class="strong" [class.secondary-color]="!leftDefaultTitle">{{
              item.subProject.project?.firstProduct?.title
            }}</span>
          </li>
          <li
            *ngIf="
              item.subProject.project.firstProduct &&
              item.subProject.project.firstProduct.doTitleSidesDiffer
            "
          >
            <span>Titel rechts: </span>
            <span class="strong" [class.secondary-color]="!rightDefaultTitle">{{
              item.subProject.project?.firstProduct?.titleRight
            }}</span>
          </li>
          <li>
            <span
              >{{
                item.subProject.project.firstProduct &&
                item.subProject.project.firstProduct.multiplePhoneNumbers
                  ? 'Telnrs'
                  : 'Telnr'
              }}
              {{
                item.subProject.project.firstProduct &&
                item.subProject.project.firstProduct.doPhoneNumberSidesDiffer
                  ? ' links'
                  : ''
              }}:
            </span>
            <span
              class="strong"
              [class.secondary-color]="!leftDefaultPhoneNumber"
              >{{ item.subProject.project?.firstProduct?.phoneNumber }}</span
            >
          </li>
          <li
            *ngIf="
              item.subProject.project.firstProduct &&
              item.subProject.project.firstProduct.doPhoneNumberSidesDiffer
            "
          >
            <span>Telnr rechts: </span>
            <span
              class="strong"
              [class.secondary-color]="!rightDefaultPhoneNumber"
              >{{
                item.subProject.project?.firstProduct?.phoneNumberRight
              }}</span
            >
          </li>
          <li
            *ngIf="
              item.subProject.project.firstProduct &&
              item.subProject.project.firstProduct.text
            "
          >
            <span
              >Tekst{{
                item.subProject.project.firstProduct &&
                item.subProject.project.firstProduct.textRight != null
                  ? ' links'
                  : ''
              }}:
            </span>
            <span class="strong">{{
              item.subProject.project?.firstProduct?.text
            }}</span>
          </li>
          <div
            *ngIf="
              textColors?.length > 0 &&
              item.subProject.project.firstProduct.text?.length
            "
          >
            (Kleur tekst{{
              item.subProject.project.firstProduct &&
              item.subProject.project.firstProduct.textRight != null
                ? ' links'
                : ''
            }}: {{ textColors }})
          </div>
          <li
            *ngIf="
              item.subProject.project.firstProduct &&
              item.subProject.project.firstProduct.textRight != null
            "
          >
            <span>Tekst rechts: </span>
            <span class="strong">{{
              item.subProject.project?.firstProduct?.textRight
            }}</span>
          </li>
          <div
            *ngIf="
              textColorsRight?.length > 0 &&
              item.subProject.project.firstProduct.textRight?.length > 0
            "
          >
            (Kleur tekst rechts: {{ textColorsRight }})
          </div>
          <li
            *ngIf="
              item.subProject.project.firstProduct &&
              item.subProject.project.firstProduct.extraBoard != null
            "
          >
            <span>Extra bord: </span>
            <ul class="inpress-ul inner-ul">
              <li>
                <span>Type: </span>
                <span class="strong">{{
                  item.subProject.project?.firstProduct?.extraBoard?.label
                }}</span>
              </li>
              <li>
                <span>Tekst: </span>
                <span class="strong">{{
                  item.subProject.project?.firstProduct?.extraBoardText
                }}</span>
              </li>
              <li>
                <span>Kleur: </span>
                <span class="strong">{{
                  item.subProject.project?.firstProduct?.extraBoardColor
                }}</span>
              </li>
            </ul>
          </li>
        </ul>

        <div
          *ngIf="
            item.subProject.project?.firstProduct?.generalExtraInfo?.length > 0
          "
          class="mt-1"
        >
          <span>Grafische info: </span>
          <span class="strong inline-flex">{{
            item.subProject.project.firstProduct.generalExtraInfo
          }}</span>
        </div>

        <div
          *ngIf="
            item.subProject.project.firstProduct != null &&
            item.subProject.project.firstProduct.stickerText != null &&
            item.subProject.project.firstProduct.stickerText.length > 0
          "
          class="strong upper-space"
        >
          Ineens met sticker op bord{{
            item.subProject.project.firstProduct.stickerTextRight?.length > 0
              ? ' (links)'
              : ''
          }}:
          <span class="secondary-color">
            {{ item.subProject.project.firstProduct.stickerText }}
          </span>
        </div>
        <div
          *ngIf="
            item.subProject.project.firstProduct != null &&
            item.subProject.project.firstProduct.stickerTextRight != null &&
            item.subProject.project.firstProduct.stickerTextRight.length > 0
          "
          class="strong upper-space"
        >
          Ineens met sticker op bord (rechts):
          <span class="secondary-color">
            {{ item.subProject.project.firstProduct.stickerTextRight }}
          </span>
        </div>

        <div
          *ngIf="
            item.subProject.project &&
            item.subProject.project.firstProduct &&
            item.subProject.project.firstProduct.spottoLogo
          "
          class="upper-space d-flex"
        >
          <img src="/assets/spotto_banner.png" class="spotto-logo" />
          <div class="spotto-text-container">
            <div class="spotto-text">Het Spotto logo toevoegen</div>
          </div>
        </div>
      </div>
      <div class="inner-picture d-flex flex-column">
        <div *ngIf="item.subProject.leftExample?.uuid" class="mb-2 text-center">
          <span
            *ngIf="item.subProject.rightExample?.uuid"
            class="strong secondary-color"
            >Links</span
          >
          <img
            class="pointer mb-2"
            *ngIf="item.subProject.leftExample?.uuid"
            [src]="'/api/assets/' + item.subProject.leftExample?.uuid"
            (click)="openLightbox(SUB_PROJECT_TYPES.BASE_PROJECT, true, true)"
          />
        </div>
        <div
          *ngIf="item.subProject.rightExample?.uuid"
          class="mb-2 text-center"
        >
          <span
            *ngIf="item.subProject.leftExample?.uuid"
            class="strong secondary-color"
            >Rechts</span
          >
          <img
            class="pointer mb-2"
            [src]="'/api/assets/' + item.subProject.rightExample?.uuid"
            (click)="openLightbox(SUB_PROJECT_TYPES.BASE_PROJECT, true)"
          />
        </div>
        <img
          class="pointer"
          *ngIf="item.subProject.firstDesignPicture?.uuid"
          [src]="'/api/assets/' + item.subProject.firstDesignPicture?.uuid"
          (click)="openLightbox(SUB_PROJECT_TYPES.BASE_PROJECT)"
        />
        <img
          class="pointer"
          *ngIf="
            item.subProject.firstDesignPicture == null &&
            item.subProject.clientUploadedPictures?.length > 0 &&
            item.subProject.clientUploadedPictures[0].uuid != null
          "
          [src]="
            '/api/assets/' + item.subProject.clientUploadedPictures[0].uuid
          "
          (click)="openClientUploadedPicturesLightbox()"
        />
      </div>
    </div>
  </mat-card>

  <mat-card
    *ngIf="item.subProject.expectedType === SUB_PROJECT_TYPES.ADJUSTMENT"
    class="mat-elevation-z0 summary-card info sold-rented"
  >
    <div class="flex-row">
      <div class="inner-info">
        <div
          *ngIf="
            item.subProject.extraInfoAdjustment != null &&
            item.subProject.extraInfoAdjustment.length > 0
          "
        >
          Aanpassing:
          <span class="strong">
            {{ item.subProject.extraInfoAdjustment }}
          </span>
        </div>
      </div>
      <div
        *ngIf="
          item.subProject.firstDesignPicture == null &&
          item.subProject.adjustmentAssets?.length > 0
        "
        class="inner-picture"
      >
        <img
          class="pointer"
          *ngIf="item.subProject.adjustmentAssets[0].uuid != null"
          [src]="'/api/assets/' + item.subProject.adjustmentAssets[0].uuid"
          (click)="openLightbox(SUB_PROJECT_TYPES.ADJUSTMENT)"
        />
      </div>
      <div
        *ngIf="item.subProject.firstDesignPicture != null"
        class="inner-picture"
      >
        <img
          class="pointer"
          *ngIf="item.subProject.firstDesignPicture?.uuid"
          [src]="'/api/assets/' + item.subProject.firstDesignPicture?.uuid"
          (click)="openLightbox(SUB_PROJECT_TYPES.ADJUSTMENT)"
        />
      </div>
    </div>
  </mat-card>

  <mat-card
    *ngIf="item.subProject.expectedType === SUB_PROJECT_TYPES.SOLDRENTED"
    class="mat-elevation-z0 summary-card info sold-rented"
  >
    <div class="flex-row">
      <div class="inner-info">
        <div>
          Sticker:
          <span
            *ngIf="item.subProject.signSticker != null; else otherSticker"
            class="strong"
          >
            {{ item.subProject.signSticker.text }}
          </span>
          <ng-template #otherSticker>
            <span class="strong secondary-color">
              {{ item.subProject.otherSticker }}
            </span>
          </ng-template>
        </div>
        <div *ngIf="item.subProject.signSticker != null" class="upper-space">
          <span
            >{{ item.subProject.signSticker.width }} cm x
            {{ item.subProject.signSticker.height }} cm</span
          >
          <br />
          <span
            >Fond: {{ item.subProject.signSticker.foundationColor }} / Tekst:
            {{ item.subProject.signSticker.textColor }}</span
          >
        </div>
        <div *ngIf="item.subProject.signSticker != null" class="upper-space">
          <span>Aantal: {{ amount }} {{ amount > 1 ? 'stuks' : 'stuk' }}</span>
        </div>
        <div
          *ngIf="
            item.subProject.extraInfoAdjustment != null &&
            item.subProject.extraInfoAdjustment.length > 0
          "
          class="upper-space"
        >
          Opmerkingen:
          <span class="strong">
            {{ item.subProject.extraInfoAdjustment }}
          </span>
        </div>
      </div>
      <div
        *ngIf="
          item.subProject.signSticker != null &&
          item.subProject.signSticker.examples?.length > 0 &&
          item.subProject.firstDesignPicture == null
        "
        class="inner-picture"
      >
        <img
          class="pointer"
          *ngIf="item.subProject.signSticker.examples[0].asset?.uuid"
          [src]="
            '/api/assets/' + item.subProject.signSticker.examples[0].asset?.uuid
          "
          (click)="openLightbox(SUB_PROJECT_TYPES.SOLDRENTED)"
        />
      </div>
      <div
        *ngIf="item.subProject.firstDesignPicture != null"
        class="inner-picture"
      >
        <img
          class="pointer"
          *ngIf="item.subProject.firstDesignPicture?.uuid"
          [src]="'/api/assets/' + item.subProject.firstDesignPicture?.uuid"
          (click)="openLightbox(SUB_PROJECT_TYPES.SOLDRENTED)"
        />
      </div>
    </div>
  </mat-card>
  <mat-card class="mat-elevation-z0 summary-card progress">
    <mat-checkbox
      *ngIf="item.required.title"
      [disabled]="finishDisabled"
      [ngModel]="item.checked.title"
      (ngModelChange)="markDoneTitle($event)"
      [class.wide]="
        printRegisteredUser &&
        item.subProject?.project?.firstProduct?.titleCheckedPrintWork
      "
    >
      <div class="d-flex justify-content-between w-100 flex-wrap">
        <span>Titel</span>
        <div
          *ngIf="
            printRegisteredUser &&
            item.subProject?.project?.firstProduct?.titleCheckedPrintWork
          "
          class="d-flex ml-1"
        >
          <div class="circle">{{ printRegisteredUser }}</div>
          <span>{{ printRegisteredDate | date : 'dd/MM/yyyy' }}</span>
        </div>
      </div>
    </mat-checkbox>
    <mat-checkbox
      *ngIf="item.required.phoneNumber"
      [disabled]="finishDisabled"
      [ngModel]="item.checked.phoneNumber"
      (ngModelChange)="markDonePhoneNumber($event)"
      [class.wide]="
        printRegisteredUser &&
        item.subProject?.project?.firstProduct?.phoneNumberCheckedPrintWork
      "
    >
      <div class="d-flex justify-content-between w-100 flex-wrap">
        <span>Telefoonnummer</span>
        <div
          *ngIf="
            printRegisteredUser &&
            item.subProject?.project?.firstProduct?.phoneNumberCheckedPrintWork
          "
          class="d-flex ml-1"
        >
          <div class="circle">{{ printRegisteredUser }}</div>
          <span>{{ printRegisteredDate | date : 'dd/MM/yyyy' }}</span>
        </div>
      </div>
    </mat-checkbox>
    <mat-checkbox
      *ngIf="item.required.text"
      [disabled]="finishDisabled"
      [ngModel]="item.checked.text"
      (ngModelChange)="markDoneText($event)"
      class="wide"
    >
      <div class="d-flex justify-content-between w-100 flex-wrap">
        <span>{{ textCheckboxLabel }}</span>
        <div
          *ngIf="
            textRegisteredUser &&
            item.subProject?.project?.firstProduct?.textPrintworkChecked
          "
          class="d-flex ml-1"
        >
          <div class="circle">{{ textRegisteredUser }}</div>
          <span>{{ textRegisteredDate | date : 'dd/MM/yyyy' }}</span>
        </div>
      </div>
    </mat-checkbox>
    <mat-checkbox
      *ngIf="item.required.spotto"
      [disabled]="finishDisabled"
      [ngModel]="item.checked.spotto"
      (ngModelChange)="markDoneSpotto($event)"
    >
      Spotto
    </mat-checkbox>
    <mat-checkbox
      *ngIf="item.required.extraBoard"
      [disabled]="finishDisabled"
      [ngModel]="item.checked.extraBoard"
      (ngModelChange)="markDoneExtraBoard($event)"
      class="wide"
    >
      <div class="d-flex justify-content-between w-100 flex-wrap">
        <span>Extra bord</span>
        <div
          *ngIf="
            extraBoardTextRegisteredUser &&
            item.subProject?.project?.firstProduct?.extraBoardCheckedPrintWork
          "
          class="d-flex ml-1"
        >
          <div class="circle">{{ extraBoardTextRegisteredUser }}</div>
          <span>{{ extraBoardTextRegisteredDate | date : 'dd/MM/yyyy' }}</span>
        </div>
      </div>
    </mat-checkbox>
    <!-- TODO: check if there is a "Ineens met sticker" checkbox -->
    <mat-checkbox
      *ngIf="
        item.required.configuration &&
        item.subProject.expectedType !== SUB_PROJECT_TYPES.BASE_PROJECT
      "
      [disabled]="finishDisabled"
      [ngModel]="item.checked.configuration"
      (ngModelChange)="markDoneConfiguration($event)"
    >
      {{
        item.subProject.expectedType === SUB_PROJECT_TYPES.SOLDRENTED
          ? 'Sticker'
          : 'Aanpassing'
      }}
    </mat-checkbox>
  </mat-card>
</div>

<!--IMMOSCOOP ROW-->
<div
  class="flex-row"
  *ngIf="
    item.subProject.project &&
    item.subProject.project.firstProduct &&
    item.subProject.project.firstProduct.immoscoopLogo &&
    item.subProject.expectedType === SUB_PROJECT_TYPES.BASE_PROJECT
  "
>
  <mat-card class="mat-elevation-z0 summary-card info base-project">
    <div class="d-flex">
      <img src="/assets/immoscoop_banner.png" class="immoscoop-logo" />
      <div class="immoscoop-text-container">
        <div class="immoscoop-text">Het Immoscoop logo toevoegen</div>
      </div>
    </div>
  </mat-card>

  <mat-card class="mat-elevation-z0 summary-card progress">
    <mat-checkbox
      *ngIf="item.required.immoscoop"
      [disabled]="finishDisabled"
      [ngModel]="item.checked.immoscoop"
      (ngModelChange)="markDoneImmoscoop($event)"
    >
      Immoscoop
    </mat-checkbox>
  </mat-card>
</div>

<div class="flex-row">
  <mat-card class="mat-elevation-z0 summary-card info">
    <div class="d-flex">
      <div class="data-container inner-info">
        <label
          *ngIf="item.subProject.expectedType === SUB_PROJECT_TYPES.SOLDRENTED"
          class="mb-0"
        >
          <ng-container
            *ngIf="
              item.subProject?.project?.firstProduct?.boardType?.ordinal ===
                BOARD_TYPE_CHOICES.DIVERGENT.ordinal;
              else regularBoard
            "
          >
            <b>
              <ng-container *ngIf="item.subProject.project.collaborative">
                Gezamenlijk
              </ng-container>
              {{ item.subProject?.project?.firstProduct?.type }}
              {{ BOARD_TYPE_CHOICES.DIVERGENT.label }}
            </b>
          </ng-container>
          <ng-template #regularBoard>
            <b>
              <ng-container *ngIf="item.subProject.project.collaborative">
                Gezamenlijk
              </ng-container>
              {{ item.subProject?.project?.firstProduct?.type }}
              {{ item.subProject?.project?.firstProduct?.format }} /
              {{ item.subProject?.project?.firstProduct?.title }}
            </b>
          </ng-template>
        </label>
        <label class="highlighted">{{
          item.subProject.projectPlacement?.address
        }}</label>

        <!-- Extra's pijltjes -->
        <ng-container
          *ngIf="
            item.subProject.project?.firstProduct?.arrows != null &&
            item.subProject.expectedType === SUB_PROJECT_TYPES.BASE_PROJECT
          "
        >
          <div class="strong darkred">+ Pijltjes</div>
          <div class="extra-info flex-col">
            <div
              *ngIf="
                item.subProject.project?.firstProduct?.arrows
                  ?.amountArrowsLeft != null
              "
            >
              <span>Aantal links: </span>
              <span class="strong">{{
                item.subProject.project.firstProduct.arrows.amountArrowsLeft
              }}</span>
            </div>
            <div
              *ngIf="
                item.subProject.project?.firstProduct?.arrows
                  ?.amountArrowsRight != null
              "
            >
              <span>Aantal rechts: </span>
              <span class="strong">{{
                item.subProject.project.firstProduct.arrows.amountArrowsRight
              }}</span>
            </div>
            <div
              *ngIf="
                item.subProject.project?.firstProduct?.arrows?.arrowsDesign
                  ?.length > 0
              "
              class="d-flex"
            >
              <span class="no-wrap">Info design: </span>
              <span class="strong">
                {{
                  item.subProject.project.firstProduct.arrows.arrowsDesign
                }}</span
              >
            </div>
            <!-- Leaving out arrows assets. If needed, go copy code from client-pending-detail -->
          </div>
        </ng-container>

        <!-- Extra's tweede bord -->
        <ng-container
          *ngIf="
            item.subProject.projectPlacement?.secondBoard?.secondBoardCopy !=
              null ||
            item.subProject.projectPlacement?.secondBoard
              ?.secondBoardConfiguration?.length > 0 ||
            item.subProject.projectPlacement?.secondBoard
              ?.secondBoardPlacementInfo?.length > 0
          "
        >
          <div class="strong darkred">+ Een tweede bord op hetzelfde pand</div>
          <div class="extra-info">
            <div
              *ngIf="
                item.subProject.projectPlacement.secondBoard.secondBoardCopy !=
                null
              "
            >
              <span>Kopie van origineel besteld bord: </span>
              <span class="strong">{{
                item.subProject.projectPlacement.secondBoard.secondBoardCopy
                  | formatBoolean
              }}</span>
            </div>
            <div
              *ngIf="
                item.subProject.projectPlacement.secondBoard
                  .secondBoardConfiguration?.length > 0
              "
            >
              <span class="preserve-line-break display-contents">
                <span>Info configuratie bord: </span>
                <span class="strong inline-flex">{{
                  item.subProject.projectPlacement.secondBoard
                    .secondBoardConfiguration
                }}</span>
              </span>
            </div>
            <div
              *ngIf="
                item.subProject.projectPlacement.secondBoard
                  .secondBoardPlacementInfo?.length > 0
              "
            >
              <span class="preserve-line-break display-contents">
                <span>Info plaatsing bord: </span>
                <span class="strong inline-flex">{{
                  item.subProject.projectPlacement.secondBoard
                    .secondBoardPlacementInfo
                }}</span>
              </span>
            </div>
          </div>
        </ng-container>

        <!-- Extra's andere bestelling -->
        <ng-container
          *ngIf="item.subProject?.projectPlacement?.otherOrderPlacementInfo"
        >
          <div class="strong darkred">+ Andere bestelling</div>
          <div class="extra-info">
            <span class="preserve-line-break display-contents">
              <span>Info plaatsing andere bestelling: </span>
              <span class="strong inline-flex">{{
                item.subProject.projectPlacement.otherOrderPlacementInfo
              }}</span>
            </span>
          </div>
        </ng-container>

        <div
          class="upper-space"
          *ngIf="item.subProject.expectedType === SUB_PROJECT_TYPES.SOLDRENTED"
        >
          <b
            >Geplaatst op:
            {{
              item.subProject.baseProjectInfo?.executionDate
                | date : 'dd/MM/yyyy'
            }}</b
          >
          <br />
          <small
            >Installateur:
            {{ item.subProject.baseProjectInfo?.placerName }}</small
          >
        </div>
      </div>

      <div
        *ngIf="item.subProject.firstExecutionAsset != null"
        class="image-container inner-picture"
      >
        <img
          [src]="'/api/assets/' + item.subProject.firstExecutionAsset.uuid"
        />
      </div>
    </div>
  </mat-card>
  <mat-card class="summary-card progress">
    <mat-checkbox
      *ngIf="item.required.secondBoard"
      [disabled]="finishDisabled"
      [ngModel]="item.checked.secondBoard"
      (ngModelChange)="markDoneSecondBoard($event)"
      class="wide"
    >
      Tweede bord zelfde pand
      <div class="d-flex justify-content-between w-100 flex-wrap">
        <span>Tweede bord zelfde pand</span>
        <!-- TODO: check if this is registered under printRegisteredUser -->
        <div
          *ngIf="
            printRegisteredUser &&
            item.subProject?.project?.firstProduct?.secondBoardCheckedPrintWork
          "
          class="d-flex ml-1"
        >
          <div class="circle">{{ printRegisteredUser }}</div>
          <span>{{ printRegisteredDate | date : 'dd/MM/yyyy' }}</span>
        </div>
      </div>
    </mat-checkbox>
    <mat-checkbox
      *ngIf="item.required.arrows"
      [disabled]="finishDisabled"
      [ngModel]="item.checked.arrows"
      (ngModelChange)="markDoneArrows($event)"
      class="wide"
    >
      <div class="d-flex justify-content-between w-100 flex-wrap">
        <span>Pijltjes</span>
        <div
          *ngIf="
            printRegisteredUser &&
            item.subProject?.project?.firstProduct?.arrowCheckedPrintWork
          "
          class="d-flex ml-1"
        >
          <div class="circle">{{ printRegisteredUser }}</div>
          <span>{{ printRegisteredDate | date : 'dd/MM/yyyy' }}</span>
        </div>
      </div>
    </mat-checkbox>
    <mat-checkbox
      *ngIf="item.required.otherOrder"
      [disabled]="finishDisabled"
      [ngModel]="item.checked.otherOrder"
      (ngModelChange)="markDoneOtherOrder($event)"
      class="wide"
    >
      <div class="d-flex justify-content-between w-100 flex-wrap">
        <span>Andere bestelling</span>
        <div
          *ngIf="
            printRegisteredUser &&
            item.subProject?.project?.firstProduct?.otherOrderCheckedPrintWork
          "
          class="d-flex ml-1"
        >
          <div class="circle">{{ printRegisteredUser }}</div>
          <span>{{ printRegisteredDate | date : 'dd/MM/yyyy' }}</span>
        </div>
      </div>
    </mat-checkbox>
  </mat-card>
</div>

<div class="flex-row">
  <mat-card class="summary-card info">
    <label class="label-m-0">
      Gewenste plaatsingsdatum:&nbsp;
      <b>
        {{
          item.subProject.projectPlacement?.placementEarliestDate
            | formatASAPDate : item.subProject.projectPlacement?.placeASAP
        }}
      </b>
    </label>

    <label>
      <b>{{ item.subProject.currentConfirmedPlacementDate }}</b>
      <ng-container *ngIf="item.subProject.project?.firstProduct?.firstPlacer">
        &nbsp;-
        {{ item.subProject.project?.firstProduct?.firstPlacer?.firstName }}
        {{ item.subProject.project?.firstProduct?.firstPlacer?.lastName }} /
        {{ item.subProject.project?.firstProduct?.firstPlacer?.phone }} /
        {{ item.subProject.project?.firstProduct?.firstPlacer?.email }}
      </ng-container>
    </label>
  </mat-card>

  <mat-card class="summary-card progress">
    <mat-checkbox
      [disabled]="reviewDisabled"
      [ngModel]="item.checked.reviewed"
      (ngModelChange)="markDoneReviewed($event)"
    >
      Gecontroleerd
    </mat-checkbox>
  </mat-card>
</div>

<div
  *ngIf="
    item.subProject.expectedType === SUB_PROJECT_TYPES.BASE_PROJECT &&
    item.subProject.stockAtBranch != null
  "
  class="flex-row"
>
  <mat-card class="summary-card info no-border">
    <label class="label-m-0">
      Bord uitgesteld: filiaal:&nbsp;
      <b>
        {{ item.subProject.stockAtBranch }}
      </b>
    </label>
  </mat-card>

  <mat-card class="summary-card progress">
    <mat-checkbox
      [disabled]="reviewDisabled"
      [ngModel]="item.checked.stockAtBranch"
      (ngModelChange)="markDoneStockAtBranch($event)"
    >
      Uitgesteld bord klaar
    </mat-checkbox>
  </mat-card>
</div>
